import { DatePipe } from '@angular/common';
import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { SchedulerService } from 'src/app/services/api/scheduler.service';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import cronstrue from 'cronstrue';
import { RouterSegments } from 'src/app/models/router-segments';
import {AuthService} from 'src/app/services/auth/auth.service';
import { ColumnFilterComponent } from '../instances-mgmt/column-filter/column-filter.component';
import moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { Permissions, Datazone, Attributes } from 'src/app/models/principal/permission';
import { TenantService } from 'src/app/services/api/tenant.service';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.SCHEDULE_READ,
    action: Permissions.SCHEDULE_READ,
  },
  {
    key: PermissionKeys.SCHEDULE_CREATE,
    action: Permissions.SCHEDULE_CREATE,
  },
  {
    key: PermissionKeys.SCHEDULE_UPDATE,
    action: Permissions.SCHEDULE_UPDATE,
  },
  {
    key: PermissionKeys.SCHEDULE_DELETE,
    action: Permissions.SCHEDULE_DELETE,
  },
];

@Component({
    selector: 'app-tenant-schedule',
    templateUrl: './tenant-schedule.component.html',
    styleUrls: ['./tenant-schedule.component.scss'],
    standalone: false
})
export class TenantScheduleComponent  implements OnInit {
private destroyRef = inject(DestroyRef);

  tenantId: string;
  displayColumns = [
    {
      key: 'selected',
      name: '',
      type: 'radioSelection',
      sortable: false,
      visible: true,
      disable: false
    },
    {
      key: 'name',
      name: translate('SCHEDULES.NAME'),
      type: 'text',
      keyLink: 'navigation',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'description',
      name: translate('SCHEDULE_DETAILS.DESCRIPTION'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'startTime',
      name: translate('SCHEDULES.START_DATE'),
      type: 'date',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'endTime',
      name: translate('SCHEDULES.END_DATE'),
      type: 'date',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'nextExecutionTime',
      name: translate('SCHEDULE_DETAILS.NEXT_RUN_DATE'),
      type: 'date',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'lastExecutionTime',
      name: translate('SCHEDULE_DETAILS.LAST_RUN_DATE'),
      type: 'date',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'frequency',
      name: translate('SCHEDULES.TRIGGERS'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'cronDefinition',
      name: translate('SCHEDULES.CRON_DEFINITION'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'startsOn',
      name: translate('SCHEDULES.START_ON'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'status',
      name: translate('SCHEDULES.STATUS'),
      type: 'status',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'scheduleSettings',
      name: '',
      type: 'settings'
    }
  ];
  schedulesLoading = true;
  showLoader = false;
  schedules: any;
  searchTerm: string = '';
  showCreateNew: boolean;
  selectedData: any;
  editEnable: boolean;
  pageName = 'schedule';
  dropdownsList: any;
  scheduleStatus: any;
  status: any;
  scheduleTriggers: any;
  selectedTriggers = [];
  triggers: any;
  filteredColumns: any;
  clearData: boolean;
  initialSchedules = [];
  selectedStatus = [];
  filterStartDate: any;
  filterEndDate: any;
  date: any;
  searchedResult = [];
  isRefreshing = false;
  selectedDate:any = [];
  PermissionKeys = PermissionKeys;
  permissionsMap: { [key: string]: boolean };
  isAWS: boolean;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, public authService:AuthService,
    public schedulerService: SchedulerService, public sidenavService: SidenavService,
    private toastrService: CustomToastrService, private permissionsService: PermissionsService, public datePipe: DatePipe,
    private dialog: MatDialog, public tenantService: TenantService) {
    
  }


  ngOnInit(): void {
    this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS ? true : false;
    });
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.SCHEDULE';
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.getSchedules();
    this.scheduleStatus = [
      {value: 'running', label: "Running",selected: false},
      {value: 'active', label: "Active",selected: false},
      {value: 'disabled', label: "Disabled",selected: false},
      {value: 'completed', label: "Completed",selected: false}
    ];
    this.scheduleTriggers = [
      {value: 'one_time', label: "One Time",selected: false},
      {value: 'cron', label: "Cron",selected: false}
    ];
    const date = [
      {value: 'Scheduled date', selected: false},
      {value: 'Next 2 hours', selected: false}
    ];
    this.dropdownsList = [
      {
        title: 'Status',
        placeholder: 'Select Status',
        options: this.scheduleStatus
      },
      {
        title: 'Triggers',
        placeholder: 'Select Triggers',
        options: this.scheduleTriggers
      },
      {
        title: 'Date',
        placeholder: 'Select Zone',
        options: date
      }
    ];

    if (localStorage.getItem('filteredScheduleStatus')) {
      const statusData = JSON.parse(localStorage.getItem('filteredScheduleStatus'));
      if (statusData) {
        this.selectedStatus = statusData;
        this.status = this.selectedStatus;
        this.dropdownsList[0].options.forEach(element => {
          if(this.selectedStatus.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }

    if (localStorage.getItem('filteredScheduleTriggers')) {
      const datazoneData = JSON.parse(localStorage.getItem('filteredScheduleTriggers'));
      if (datazoneData) {
        this.selectedTriggers = datazoneData;
        this.triggers = this.selectedTriggers;
        this.dropdownsList[1].options.forEach(element => {
          if(this.selectedTriggers.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }

    if (localStorage.getItem('filteredScheduleDate')) {
      const dateData = JSON.parse(localStorage.getItem('filteredScheduleDate'));
      if (dateData) {
        this.selectedDate=dateData;
        this.date = this.selectedDate;
        this.dropdownsList[2].options.forEach(element => {
          if(this.selectedDate.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    this.filterStartDate = localStorage.getItem('filteredScheduleStartDate') ? localStorage.getItem('filteredScheduleStartDate'): '';
    this.filterEndDate = localStorage.getItem('filteredScheduleEndDate') ? localStorage.getItem('filteredScheduleEndDate'): '';
  }


  getSchedules(): void {
    this.editEnable = false;
    this.selectedData = undefined;
    this.schedulerService.getSchedules(this.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        if (response.total > 10) {
          const size = response.total
          this.schedulerService.getSchedules(this.tenantId, size)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(results => {
              results.data = results.data?.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
              this.schedulesLoading = false;
              this.showLoader = false;
              const modifiedData= results?.data?.map((obj) => ({...obj,startsOn: this.formatDurationFromNow(obj.startTime)}));
              this.schedules = modifiedData;
              this.initialSchedules =modifiedData;
              this.initialFilterItems();
              this.schedules.forEach(item => item.cronDefinition = item.cronExpression ? cronstrue.toString(item.cronExpression) : '');
            })
        } else {
          response.data = response.data?.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
          this.schedulesLoading = false;
          this.showLoader = false;
          const modifiedData= response?.data?.map((obj) => ({...obj,startsOn: this.formatDurationFromNow(obj.startTime)}));
          this.schedules = modifiedData;
          this.initialSchedules = modifiedData;
          this.initialFilterItems();
          this.schedules.forEach(item => item.cronDefinition = item.cronExpression ? cronstrue.toString(item.cronExpression) : '');
        }
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }
  /**
   * 
   * @param startISO getting ISO format startTime from response
   * @returns converting the starttime to duration format(00 Hr 00 Min 00 Sec)
   */
  formatDurationFromNow(startISO: string): string {
    const startTime = new Date(startISO);
    const currentTime = new Date();
    let diff = Math.floor(Math.abs(currentTime.getTime() - startTime.getTime()) / 1000);
    const startDateUTC = Date.UTC(startTime.getUTCFullYear(), startTime.getUTCMonth(), startTime.getUTCDate());
    const todayDateUTC = Date.UTC(currentTime.getUTCFullYear(), currentTime.getUTCMonth(), currentTime.getUTCDate());
    if (startDateUTC === todayDateUTC && diff <=0) {return '00 hr 00 min 00 sec';}
    if (startDateUTC >= todayDateUTC  && diff > 0 && startTime>=currentTime) {
    const hrs = Math.floor(diff / 3600);
    diff %= 3600;
    const mins = Math.floor(diff / 60);
    const secs = diff % 60;
    return `${hrs} hr ${mins} min ${secs.toString().padStart(2, '0')} sec`;
   }
   if (startTime < currentTime ) {return null;}
  }
  refreshClick(): void {
    this.isRefreshing = true;
    this.getSchedules();
    this.showLoader = true;
    setTimeout(() => {
      this.isRefreshing = false;
    }, 1000);
  }

  search(searchTerm?: string): void {
    this.searchTerm = searchTerm;
  }

  searchedItems(result): void {
    this.searchedResult = result;
  }

  onCreateNewSchedule(): void {
    this.router.navigate(['/',this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.SCHEDULE, 'create']);
  }

  editSchedule(): void {
    this.router.navigate(['/',this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.SCHEDULE,this.selectedData.id,'update']);
  }

  getApproveData(data): void {
    this.editEnable = true;
    this.selectedData = data;
  }

  filterColumns(): void {
    if(this.status) {
      this.dropdownsList[0].options.filter((item) => {
        if (this.status?.find(status => status === item.value)) {
          item.selected = true;
        }
      });
    }
    if(this.triggers) {
        this.dropdownsList[1].options.filter((item) => {
          if (item.value === this.triggers) {
            item.selected = true;
          }
        });
      }
      if(this.date) {
        this.date.forEach(date => {
          this.dropdownsList[2].options.filter((item) => {
            if (item.value === date) {
              item.selected = true;
            }
          });
        })
      }
    const data = {
      name: translate('SCHEDULES.SCHEDULE_FILTERS'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.dropdownsList,
      scheduleStatusList: this.dropdownsList[0].options,
      scheduleTriggerList: this.dropdownsList[1].options,
      scheduleDate: this.dropdownsList[2].options,
      scheduleStartDate: this.dropdownsList[2].options[0]?.selected ? moment(this.filterStartDate) : '',
      scheduleEndDate: this.dropdownsList[2].options[0]?.selected ? moment(this.filterEndDate) : '',
      scheduleColumns: [
        'status',
        'triggers',
        'date'
      ]
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(filteredColumns => {
      this.filteredColumns = filteredColumns;
      if (filteredColumns) {
        this.clearData = true;
        if(filteredColumns[0] !== '') {
          this.status = filteredColumns[0];
        }
        if (filteredColumns[1] !== '') {
          this.triggers = filteredColumns[1];
        }
        if(filteredColumns[2] !== '') {
          localStorage.removeItem('filteredScheduleDate');
          this.date = filteredColumns[2];
          localStorage.setItem('filteredScheduleDate', JSON.stringify(filteredColumns[2]));
        }
        if (filteredColumns[0]?.length === 0 && filteredColumns[1]?.length === 0 && filteredColumns[2]?.length === 0){
          this.resetScheduleFilter();
        } else {
          this.filterScheduleItems(filteredColumns);
        }
      }
    });
  }

  filterScheduleItems(filteredColumns): void {
    this.schedules = this.initialSchedules;
    if(!filteredColumns){
      this.initialFilterItems()
    }
    if (filteredColumns) {
      this.selectedStatus = [];
      this.selectedTriggers = [];
      this.selectedDate=[];

      if (filteredColumns[0]?.length > 0) {
        this.selectedStatus = filteredColumns[0];
        if (filteredColumns[0].length > 0) {
          localStorage.setItem('filteredScheduleStatus', JSON.stringify(this.selectedStatus));
          this.schedules = this.schedules?.filter(item => this.selectedStatus?.includes(item?.status));
        } else {
          localStorage.removeItem('filteredScheduleStatus');
        }
      }

      if (filteredColumns[1]?.length > 0) {
        this.selectedTriggers = filteredColumns[1];
        if (filteredColumns[1].length > 0) {
          localStorage.setItem('filteredScheduleTriggers', JSON.stringify(this.selectedTriggers));
          this.schedules = this.schedules?.filter(item => this.selectedTriggers?.includes(item?.frequency));
        } else {
          localStorage.removeItem('filteredScheduleTriggers');
        }
      }

      if (filteredColumns[2]?.length > 0) {
        this.selectedDate = filteredColumns[2];
        localStorage.setItem('filteredScheduleDate', JSON.stringify(this.selectedDate));
      if (this.dropdownsList[2].options[0].selected && moment(filteredColumns[3].filteredStartDate).isValid() && moment(filteredColumns[3].filteredEndDate).isValid()) {
        this.filterStartDate = filteredColumns[3].filteredStartDate;
        this.filterEndDate = filteredColumns[3].filteredEndDate;
        localStorage.setItem('filteredScheduleStartDate', this.filterStartDate);
        localStorage.setItem('filteredScheduleEndDate', this.filterEndDate);
        this.schedules = this.schedules?.filter(item => item.frequency !== 'one_time' ? (this.datePipe.transform(item.startTime, 'yyyy-MM-dd') >= this.datePipe.transform(this.filterStartDate, 'yyyy-MM-dd') &&
          this.datePipe.transform(item.endTime, 'yyyy-MM-dd') <= this.datePipe.transform(this.filterEndDate, 'yyyy-MM-dd')) : this.datePipe.transform(item.startTime, 'yyyy-MM-dd') >= this.datePipe.transform(this.filterStartDate, 'yyyy-MM-dd') &&
          this.datePipe.transform(item.startTime, 'yyyy-MM-dd') <= this.datePipe.transform(this.filterEndDate, 'yyyy-MM-dd'));
      }
       else {
        this.filterStartDate = undefined;
        this.filterEndDate = undefined;
        localStorage.removeItem('filteredScheduleStartDate');
        localStorage.removeItem('filteredScheduleEndDate');
      }
      if (this.dropdownsList[2].options[1].selected) {this.FilterNextSchedule()}
      } else {
          localStorage.removeItem('filteredScheduleTriggers');
      }
    }
  }

  initialFilterItems() {
    this.schedules = this.initialSchedules;
    if (this.selectedStatus?.length > 0) {
      this.schedules = this.schedules?.filter(item => this.selectedStatus?.includes(item?.status));
    }

    if (this.selectedTriggers?.length > 0) {
      this.schedules = this.schedules?.filter(item => this.selectedTriggers?.includes(item?.frequency));
    }
    if(this.selectedDate?.length > 0){
    if (this.dropdownsList[2].options[0].selected && this.filterStartDate && this.filterEndDate) {
      this.schedules = this.schedules?.filter(item => item.frequency !== 'one_time' ? (this.datePipe.transform(item.startTime, 'yyyy-MM-dd') >= this.datePipe.transform(this.filterStartDate, 'yyyy-MM-dd') &&
        this.datePipe.transform(item.endTime, 'yyyy-MM-dd') <= this.datePipe.transform(this.filterEndDate, 'yyyy-MM-dd')) : this.datePipe.transform(item.startTime, 'yyyy-MM-dd') >= this.datePipe.transform(this.filterStartDate, 'yyyy-MM-dd') &&
        this.datePipe.transform(item.startTime, 'yyyy-MM-dd') <= this.datePipe.transform(this.filterEndDate, 'yyyy-MM-dd'));
    }
    if(this.dropdownsList[2].options[1].selected){
      this.FilterNextSchedule()
    }
    }
  }

  getUTCTimestamp(date): any {
    return Date.parse(moment(new Date(date)).utc().format('DD MMM YYYY HH:mm:ss'));
  }

  getStatusLabel(status): void {
    return this.scheduleStatus.find(item=> item.value === status).label;
  }

  cancelStatusFilter(data) {
    let selectedItem = this.selectedStatus.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredScheduleStatus');
      this.selectedStatus.splice(selectedItem, 1);
      this.dropdownsList[0].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredScheduleStatus', JSON.stringify(this.selectedStatus));
      this.filterScheduleItems(this.filteredColumns);
    }
  }

  cancelTriggerFilter(data) {
    let selectedItem = this.selectedTriggers.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredScheduleTriggers');
      this.selectedTriggers.splice(selectedItem, 1);
      this.dropdownsList[1].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredScheduleTriggers', JSON.stringify(this.selectedTriggers));
      this.filterScheduleItems(this.filteredColumns);
    }
  }

  cancelScheduleDateFilter(data) {
    let selectedItem = this.selectedDate.indexOf(data);
    if(data !== 'Next 2 hours'){
        this.filterStartDate = undefined;
        this.filterEndDate = undefined;
    }
    if (selectedItem > -1) {
      localStorage.removeItem('filteredScheduleDate');
      if(data !== 'Next 2 hours'){
        localStorage.removeItem('filteredScheduleStartDate');
        localStorage.removeItem('filteredScheduleEndDate');
        this.date?.forEach(element => {
          if(element.includes(this.dropdownsList[2].options[0].value)) {
            this.date.pop(element);
          } 
        });
      }
      this.selectedDate.splice(selectedItem, 1);
      this.dropdownsList[2].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredScheduleDate', JSON.stringify(this.selectedDate));
      this.filterScheduleItems(this.filteredColumns);
    }
  }

  resetScheduleFilter(): void {
    this.selectedStatus = [];
    this.selectedTriggers = [];
    this.selectedDate=[];
    this.sidenavService.searchFilter.next('data');
    this.dropdownsList[0].options.filter((item) => {item.selected = false});
    this.dropdownsList[1].options.filter((item) => {item.selected = false});
    this.dropdownsList[2].options.filter((item) => {item.selected = false});
    this.status = undefined;
    this.triggers = undefined;
    this.date = undefined;
    this.filterStartDate = undefined;
    this.filterEndDate = undefined;
    this.schedules = this.initialSchedules;
    localStorage.removeItem('filteredScheduleStatus');
    localStorage.removeItem('filteredScheduleTriggers');
    localStorage.removeItem('filteredScheduleDate');
    localStorage.removeItem('filteredScheduleStartDate');
    localStorage.removeItem('filteredScheduleEndDate');
  }

  onDeleteSchedule(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('SCHEDULES.DELETE_TITLE'),
        message: translate('SCHEDULES.DELETE_MESSAGE'),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (confirmed) => {
          if (!confirmed) {
            return;
          }

          this.schedulerService
            .deleteSchedule(this.tenantId, this.selectedData.id)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
              next: (res) => {
                if (res?.httpStatusCode === 204) {
                this.getSchedules();
            setTimeout(() => {
			  const title = translate('SCHEDULES.SCHEDULES');
              const message = translate('SCHEDULES.SCHEDULE_DELETE_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
          }
              },
              error: (err) => {
                this.showErrorDialog(err, 'ERROR_DIALOG.DELETE_SCHEDULE_FAILED');
              }
            });
        },
        error: (err) => {
          this.showErrorDialog(err, 'ERROR_DIALOG.DELETE_SCHEDULE_NOT_AVAILABLE');
        }

      });
  }



  private showErrorDialog(error: any, titleKey: string): void {
    const errorMessage = typeof error === 'string'
      ? error
      : typeof error?.error === 'string'
        ? error.error
        : 'An unknown error occurred.';

    this.dialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '630px',
      panelClass: 'flex-dialog',
      data: {
        title: translate(titleKey),
        description: errorMessage
      }
    });
  }

  onDisableSchedule(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('SCHEDULES.DISABLE_TITLE'),
        message: translate('SCHEDULES.DISABLE_MESSAGE'),
        scheduleName: this.selectedData.name.includes('-') ? this.selectedData.name.split('-')[0].trim() : this.selectedData.name,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
        this.schedulerService.scheduleDisable(this.tenantId, this.selectedData.id)
        .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(data => {
            if (data?.httpStatusCode === 202) {
              this.getSchedules();
              setTimeout(() => {
                const title = translate('TENANT_LAYOUT.MENU.SCHEDULE');
                const message = translate('SCHEDULES.DISABLED_SUCCESS_MSG');
                this.toastrService.successMessage(message, title);
              }, 500);
            }
          }, (error) => {
            const description = error?.message 
            || error?.error?.message 
            || error?.errmsg 
            || translate('SERVICE.INTERNAL_SERVER_ERROR');
            setTimeout(() => {
              this.openErrorDialog(error);
            }, 500);
          })
      }
  })
    
  }

  onEnableSchedule(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('SCHEDULES.ENABLE_TITLE'),
        message: translate('SCHEDULES.ENABLE_MESSAGE'),
        scheduleName: this.selectedData.name.includes('-') ? this.selectedData.name.split('-')[0].trim() : this.selectedData.name,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(confirm => {
      if (confirm) {
      this.schedulerService.scheduleEnable(this.tenantId, this.selectedData.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(data => {
          if (data?.httpStatusCode === 202) {
            this.getSchedules();
            setTimeout(() => {
              const title = translate('TENANT_LAYOUT.MENU.SCHEDULE');
              const message = translate('SCHEDULES.ENABLED_SUCCESS_MSG'); 
              this.toastrService.successMessage(message, title);
            }, 500);
          }
        }, (error) => {
          const description = error?.message 
          || error?.error?.message 
          || error?.errmsg 
          || translate('SERVICE.INTERNAL_SERVER_ERROR');
          setTimeout(() => {
            this.openErrorDialog(error);
          }, 500);
        })
    }
})
  }

  // Error block
  openErrorDialog(data): void {
    this.dialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '630px',
      panelClass: 'flex-dialog',
      data: {
        title: translate('SCHEDULE_DETAILS.SCHEDULE_VALIDATION_ERROR'),
        descriptionError: data
      }
    });
  }
  /**
   * Filtering Jobs scheduled to run in next 2 hours
   */
  FilterNextSchedule(){
    const today = new Date();  // current time
    const todaytime = today.getTime();
    const twoHoursLater = todaytime + 2 * 60 * 60 * 1000; // now + 2 hours
    this.schedules = this.schedules.filter(item => {
      const execTime = new Date(item.startTime).getTime(); 
      return execTime >= todaytime && execTime <= twoHoursLater;
    });
  }
}